<div class="exception-body access">
  <div class="exception-content">
    <div class="moon">
      <img src="assets/img/portal/asset-moon.svg" alt="mirage-layout" />
    </div>
    <div class="exception-panel">
      <div class="exception-panel-content">
        <h1>Access Denied</h1>
        <div class="seperator"></div>
        <p>You do not have the necessary permissions.</p>
        <button *ngIf="isValidUser" pButton type="button" [routerLink]="['/']" label="Go To Dashboard"></button>
        <button *ngIf="!isValidUser" pButton type="button" (click)="logout()" label="Log Out"></button>
      </div>
    </div>
    <div class="desert"></div>
  </div>
</div>
